// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"825f34e568691483d86a","245":"255fa6e85a0e6a5ebbb0","452":"0bc42fdbd8dc6e2189b6","453":"8bbcf4426043e3420a06"}[chunkId] + ".js";
};